/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { ILeaseLookup } from './progressive-proxy-files/ProgressiveDataServiceEntities.g';

/**
 * ProgressiveSetLeaseLookupInfo Action
 */
export class ProgressiveSetLeaseLookupInfoInput implements Msdyn365.IActionInput {
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ProgressiveSetLeaseLookupInfo`;
    public getCacheObjectType = () => 'ProgressiveSetLeaseLookupInfo';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IProgressiveSetLeaseLookupInfoData {
    leaseLookupByCustomerInfo?: ILeaseLookup;
}

/**
 * ProgressiveSetLeaseLookupInfo Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ProgressiveSetLeaseLookupInfoInput();
};
/**
 * ProgressiveSetLeaseLookupInfo Use this function to call your action and process the results as needed
 */
async function action(input: ProgressiveSetLeaseLookupInfoInput, ctx: Msdyn365.IActionContext): Promise<IProgressiveSetLeaseLookupInfoData> {
    return { leaseLookupByCustomerInfo: undefined };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IProgressiveSetLeaseLookupInfoData>>action,
    id: 'ProgressiveSetLeaseLookupInfo',
    input: createInput
});
